// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  touch-action: none;
}

.chart {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.pressure-unit,
.time-unit {
  position: absolute;
  font-size: var(--font-size-smallest);
  color: var(--color-teal-light);
}

.pressure-unit {
  top: 0;
  left: var(--spacing-smaller);
  text-align: left;
}

.time-unit {
  bottom: var(--spacing-smallest);
  right: var(--spacing-small);
  text-align: right;
}

.reset-button-wrapper {
  position: absolute;
  top: var(--spacing-larger);
  left: var(--spacing-largest);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing-large);
}

.reset-zoom-button {
  transform: scale(1.2);
}

.chart-area-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
}

.chart-area-wrapper > * {
  pointer-events: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/patient/components/graph.common.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EAEA,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAAF;;AAGA;;EAEE,kBAAA;EACA,oCAAA;EACA,8BAAA;AAAF;;AAGA;EACE,MAAA;EACA,4BAAA;EACA,gBAAA;AAAF;;AAGA;EACE,+BAAA;EACA,2BAAA;EACA,iBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,0BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,oBAAA;AAAF","sourcesContent":[":host {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n  // Disable the browser's gesture detection (that messes with event handlers)\n  touch-action: none;\n}\n\n.chart {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.pressure-unit,\n.time-unit {\n  position: absolute;\n  font-size: var(--font-size-smallest);\n  color: var(--color-teal-light);\n}\n\n.pressure-unit {\n  top: 0;\n  left: var(--spacing-smaller);\n  text-align: left;\n}\n\n.time-unit {\n  bottom: var(--spacing-smallest);\n  right: var(--spacing-small);\n  text-align: right;\n}\n\n.reset-button-wrapper {\n  position: absolute;\n  top: var(--spacing-larger);\n  left: var(--spacing-largest);\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: var(--spacing-large);\n}\n\n.reset-zoom-button {\n  transform: scale(1.2);\n}\n\n.chart-area-wrapper {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.chart-area-wrapper > * {\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
